import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,Link,useNavigate } from 'react-router-dom';
import LogoX from './../../assets/icons/logo.png';
import Waiter from './../../assets/gif/blueCircle.gif';
import Waiter_Black_Ring from './../../assets/gif/giphy.gif';
import DashboardSelectInputForm from './../card/dashboardSelectInputForm';
import CreateDocument from './../forms/createDocument';
import CreateNewUser from './../forms/createNewUser';
import UpdateCredential from './../forms/updateCredential';
import TableAssets from './../table/JTableAssets';
import TableWorkingAssets from './../table/JTableWorkingAssets';
import TableUsers from './../table/JTableUserList';
import TableSingleDocumentDetails from './../table/TableSingleDocumentDetails'
import NearestAssetsProjects from "./../reports/NearestAssetsProjects";
import ContractorPerformance from "./../reports/ContractorPerformance";
import AssetsProjectsReport from "./../reports/AssetsProjectsReport";
import ImplementingAgencyReport from "./../reports/ImplementingAgencyReport"
import JTableAssetsOf from	"../table/JTableAssetsOf";
import JTablePublicRemarks from	"../table/JTablePublicRemarks"; 
import OpenstreetMap from	"./../openstreetmap/Map";
import PaymentAdd from "./../../payment/AddPayment";
import PaymentInfo from "./../../payment/PaymentInformation";
import CreateImplementingAgency from  "./../../mastersettings/CreateImplementingAgency";
import CreateUserAgency from  "./../../mastersettings/CreateUserAgency";
import CreateFundingAgency from  "./../../mastersettings/CreateFundingAgency";
import CreateAssetType from "./../../mastersettings/CreateAssetType";
import AddEngineer from "./../../mastersettings/AddEngineer";
import { createGlobalStyle } from 'styled-components';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
import $ from 'jquery';
let fxYesEvent=null;
let fxNoEvent=null;
const JComponent= ({formId}) => {
    const navigate=useNavigate();
	const [flag,setFlag]=useState(0);
	useEffect(()=>{
		const _s=localStorage.getItem("_lio");
		if(_s!=null  && _s.length!=0){
			setFlag(1);
		}
	},[])
    const [role,setRole]=useState("");
	useEffect(()=>{
		/*const _s=localStorage.getItem("_lio");
		if(_s!=null  && _s.length!=0){
			$.post(API_CORE_SERVER+"/api/user/getStatus.php","i="+_s,async function(result) {
				if(result.status===1 && result.data=="fa246d0262c3925617b0c72bb20eeb1d"){ 
					setRole("9999");
				}
			});
		}*/
		if(localStorage.getItem("_xoxre")==="9999"){
			setRole("9999");
		}
		
	},[])  
  const modals={
	ok:(_msg)=>{setTextOkModal(_msg);setShowOkModal(true);},
	yesNo:(_msg,_fx,_fy)=>{setTextOkModal(_msg);setShowYesNoModal(true);fxYesEvent=_fx;fxNoEvent=_fy;},
	waiting:(_msg,_flag)=>{setTextOkModal(_msg);if(_flag)setHttpRequestWaitingModal(true);else setHttpRequestWaitingModal(false);},
	
  };
  const [showOkModal,setShowOkModal]=useState(false);
  const [showYesNoModal,setShowYesNoModal]=useState(false);
  const [httpRequestWaitingModal,setHttpRequestWaitingModal]=useState(false);
  
  const [textOkModal,setTextOkModal]=useState("It is okay");
  const [modalObject,setModalObject]=useState(modals);
  const noListener=()=>{
	setShowYesNoModal(false);
  }	 
  const yesListener=()=>{
	fxYesEvent();
	setShowYesNoModal(false);
  }  

  const getTokenOf=(_title)=>{
	return(_title);
  }
  return(

<>
<div className="container-fluid">
    <div className="row flex-nowrap">
        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0 privateSidebar">
            <div className="d-flex flex-column  px-3 pt-2  min-vh-100">
                <div className="d-flex align-items-center pb-3 mb-md-0 me-md-auto text-white text-decoration-none">
                    <span className="fs-6  text-dark"><i class="bi bi-person"></i> <span class="badge bg-info">{localStorage.getItem("_xoxdpn")}</span></span>
                </div>
                <ul className="nav nav-pills" id="menu">
                
                    <li className="nav-item">
                        <Link to={URLPREFIX+"/view/dashboard"} className="nav-link align-middle px-0">
                            <i className="bi bi-columns-gap"></i><span className="ms-1">Dashboard</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to={URLPREFIX+"/create/document"} className="nav-link align-middle px-0">
                            <i className="bi bi-layers"></i><span className="ms-1">Create Assets</span>
                        </Link>
                    </li>
					
					<li className="nav-item">
                        <Link to={URLPREFIX+"/view/openstreet-map"} className="nav-link align-middle px-0">
                            <i className="bi bi-map"></i><span className="ms-1">Assets on Map</span>
                        </Link>
                    </li>
					<li className="nav-item">
                        <Link to={URLPREFIX+"/list/document"} className="nav-link align-middle px-0">
                            <i className="bi bi-list-columns-reverse"></i><span className="ms-1">List Assets &amp; Projects</span>
                        </Link>
                    </li>
					<li className="nav-item">
                        <Link to={URLPREFIX+"/working/document"} className="nav-link align-middle px-0">
                            <i className="bi bi-list-columns-reverse"></i><span className="ms-1">Work Updated List</span>
                        </Link>
                    </li>
					<li className="nav-item">
                        <Link to={URLPREFIX+"/list/document/nearto"} className="nav-link align-middle px-0">
                            <i className="bi bi-arrows-move"></i><span className="ms-1">Nearest Projects</span>
                        </Link>
                    </li>
					<li className="nav-item">
                        <Link to={URLPREFIX+"/list/document/contractor-performance"} className="nav-link align-middle px-0">
                            <i className="bi bi-arrows-move"></i><span className="ms-1">Contractor Performance</span>
                        </Link>
                    </li>
					<li className="nav-item">
                        <Link to={URLPREFIX+"/list/public/remarks"} className="nav-link align-middle px-0">
                            <i className="bi bi-hash"></i><span className="ms-1">Public Remarks</span>
                        </Link>
                    </li>
					{role==="9999"?
					<li>
                        <a href="#submenu3report" data-bs-toggle="collapse" className="nav-link px-0 align-middle">
                            <i className="bi-grid"></i><span className="ms-1">Reports</span> 
                        </a>
                            <ul className="collapse nav flex-column ms-1" id="submenu3report" data-bs-parent="#menu">
                           
								<li className="w-100">
									<Link to={URLPREFIX+"/report/assets-projects"} className="nav-link px-0"><span className="">Assets and Projects</span></Link>
								</li>
								
								<li className="w-100">
									<Link to={URLPREFIX+"/report/implementing-agency"} className="nav-link px-0"><span className="">Implementing Agency</span></Link>
								</li>
                        </ul>
                    </li>
					
					:null}
					<li>
                        <a href="#submenuPayment" data-bs-toggle="collapse" className="nav-link px-0 align-middle">
                            <i className="bi-file"></i><span className="ms-1">Payment</span> 
                        </a>
                            <ul className="collapse nav flex-column ms-1" id="submenuPayment" data-bs-parent="#menu">
                           
								<li className="w-100">
									<Link to={URLPREFIX+"/payment/add"} className="nav-link px-0"><span className="">Add Payment</span></Link>
								</li>
								
								<li className="w-100">
									<Link to={URLPREFIX+"/payment/info"} className="nav-link px-0"><span className="">Payment Information</span></Link>
								</li>
                        </ul>
                    </li>
                    
					{role==="9999"?
					<li>
                        <a href="#submenu3setting" data-bs-toggle="collapse" className="nav-link px-0 align-middle">
                            <i className="bi bi-gear"></i><span className="ms-1">Master Setting</span> 
                        </a>
                            <ul className="collapse nav flex-column ms-1" id="submenu3setting" data-bs-parent="#menu">
                            
                                <>
                                    <li className="w-100">
                                        <Link to={URLPREFIX+"/create/user"} className="nav-link px-0"><span className="">Create User</span></Link>
                                    </li>
                                    <li>
                                        <Link to={URLPREFIX+"/create/implAgency"} className="nav-link px-0"><span className="">Implementing Agency</span></Link>
                                    </li>
									<li>
                                        <Link to={URLPREFIX+"/create/userAgency"} className="nav-link px-0"><span className="">User Agency</span></Link>
                                    </li>
									<li>
                                        <Link to={URLPREFIX+"/create/fundingAgency"} className="nav-link px-0"><span className="">Funding Agency</span></Link>
                                    </li>
									<li>
                                        <Link to={URLPREFIX+"/create/assetType"} className="nav-link px-0"><span className="">Asset Type</span></Link>
                                    </li>
									<li>
                                        <Link to={URLPREFIX+"/add/engineer"} className="nav-link px-0"><span className="">Add Engineer</span></Link>
                                    </li>
									
									<li>
                                        <Link to={URLPREFIX+"/list/user"} className="nav-link px-0"><span className="">List Users</span></Link>
                                    </li>
									
                                </>
                               
                            
                        </ul>
                    </li>
					 :
					 <>
						 
					 </>
					}
                    
                </ul>
                <hr/>
                
            </div>
        </div>
        <div className="col p-4">
			<div className=''>
				{/*<GraduationCertificate modalObject={modalObject} />*/}
					{formId===getTokenOf("dashboard")?<><DashboardSelectInputForm modalObject={modalObject} /></>
						:formId===getTokenOf("create-asset-type")?<><CreateAssetType modalObject={modalObject} /></>
						:formId===getTokenOf("create-user")?<><CreateNewUser modalObject={modalObject} /></>
						:formId===getTokenOf("create-impl-agency")?<><CreateImplementingAgency modalObject={modalObject} /></>
						:formId===getTokenOf("create-user-agency")?<><CreateUserAgency modalObject={modalObject} /></>
						:formId===getTokenOf("create-funding-agency")?<><CreateFundingAgency modalObject={modalObject} /></>
						:formId===getTokenOf("add-engineer")?<><AddEngineer modalObject={modalObject} /></>
						:formId===getTokenOf("create-document")?<><CreateDocument modalObject={modalObject} /></>
						:formId===getTokenOf("working-list-document")?<><TableWorkingAssets modalObject={modalObject} /></>
                        :formId===getTokenOf("list-document")?<><TableAssets modalObject={modalObject} /></>
                        :formId===getTokenOf("list-user")?<><TableUsers modalObject={modalObject} /></>
                        :formId===getTokenOf("update-credential")?<><UpdateCredential modalObject={modalObject}/></>
                        :formId===getTokenOf("document-details")?<><TableSingleDocumentDetails modalObject={modalObject}/></>
						:formId===getTokenOf("report-assets-projects")?<><AssetsProjectsReport modalObject={modalObject}/></>
						:formId===getTokenOf("report-implementing-agency")?<><ImplementingAgencyReport modalObject={modalObject}/></>
						:formId===getTokenOf("list-document-implementing-agency-vbadmin")?<><JTableAssetsOf modalObject={modalObject}/></>
						:formId===getTokenOf("list-document-assettype-vbadmin")?<><JTableAssetsOf modalObject={modalObject}/></>
						:formId===getTokenOf("list-document-contractor-vbadmin")?<><JTableAssetsOf modalObject={modalObject}/></>
						:formId===getTokenOf("list-document-delayed-between-days")?<><JTableAssetsOf modalObject={modalObject}/></>
						:formId===getTokenOf("openstreet-map")?<><OpenstreetMap modalObject={modalObject} /></>
						:formId===getTokenOf("nearest-assets-projects")?<><NearestAssetsProjects modalObject={modalObject}/></>
						:formId===getTokenOf("contractor-performance")?<><ContractorPerformance modalObject={modalObject}/></>
						:formId===getTokenOf("public-remarks")?<><JTablePublicRemarks modalObject={modalObject}/></>
						:formId===getTokenOf("payment-add")?<><PaymentAdd/></>
						:formId===getTokenOf("payment-info")?<><PaymentInfo/></>
						:null
					}
			</div>
        </div>
    </div>
</div>
	{showOkModal===true &&
	<>
		<div className="position-fixed top-0 w-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4">
				<div className="cursor-pointer text-dark" onClick={()=>{
					setShowOkModal(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row w-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Alert </div>
					<div className='text-center text-black fs-6' >{ textOkModal }</div>
					<div className='pt-4 text-end' ><button className='btn btn-secondary' onClick={()=>{
					setShowOkModal(false);
				}}>Ok</button></div>
				</div>
				</div>
			</div>
		</div>
	</>
	}
	{showYesNoModal===true &&
	<>
		<div className="position-fixed top-0 w-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4">
				<div className="cursor-pointer text-dark" onClick={()=>{
					setShowYesNoModal(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row w-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-info-square-fill"></i> Alert </div>
					<div className='text-center text-black fs-6' >{ textOkModal }</div>
					<div className='pt-4 text-end' >
						<button className='btn btn-secondary me-2' onClick={()=>{
						yesListener();
						}}>Yes</button>
						<button className='btn btn-secondary' onClick={()=>{
						noListener();	
						}}>No</button>
					</div>
				</div>
				</div>
			</div>
		</div>
	</>
	}
	{httpRequestWaitingModal===true &&
	<>
		<div className="position-fixed top-0 w-100 vh-100 bg-light" style={{zIndex:99999999,opacity:0.95}}>
			<div className="d-flex justify-content-end p-4">
				<div className="cursor-pointer text-dark" onClick={()=>{
					setHttpRequestWaitingModal(false);
				}}>Close</div>
			</div>
			<div className='d-flex vh-100 align-items-center'>
				<div className='row w-100' style={{marginTop:'-8rem'}}>
				<div className='col-md-5 mx-auto border rounded-2 p-4'>
					<div className='text-left fs-6 mb-4 text-secondary' ><i className="bi bi-stopwatch-fill"></i> Wait </div>
					<div className='text-center text-black fs-6 mb-2' ><img src={Waiter_Black_Ring} style={{width:'48px'}} /></div>
					<div className='text-center text-black fs-6' >{ textOkModal }</div>
					<div className='pt-4 text-end' ></div>
				</div>
				</div>
			</div>
		</div>
	</>
	}
</>
	);
};
export default JComponent;